// extracted by mini-css-extract-plugin
export default {"button":"ConstructorVideoButton_button__lS1zR","active":"ConstructorVideoButton_active__PeZgl","inactive":"ConstructorVideoButton_inactive__b0+jD"};